import request from '@/services/request'

export function history(data) {
  return request({
    url: process.env.BASE_URL_REPORT + '/history',
    method: 'get',
    params: data
  })
}

export function store() {
  return request({
    url: process.env.BASE_URL_REPORT + '/store',
    method: 'get'
  })
}

export function best_sale(data) {
  return request({
    url: process.env.BASE_URL_REPORT + '/best_sale',
    method: 'get',
    params: data
  })
}

export function config() {
  return request({
    url: process.env.BASE_URL_REPORT + '/system/config',
    method: 'get'
  })
}

export function order_processing_time(data) {
  return request({
    url: process.env.BASE_URL_REPORT + '/order-processing-time',
    method: 'get',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/api/report.js